export default __webpack_public_path__ + "static/media/img10.f4ac8f38.png";